<google-map [options]="mapOptions">
    <map-marker [position]="marker.position"></map-marker>
</google-map>